import store from '@/store'
import Vue from 'vue'
import { http } from '@/utils/http'
import VueI18n from '@/i18n'
import { removeStorage } from '@/utils/storage'
const language = VueI18n.locale

const baseUrl = window.SITE_CONFIG['apiURL']
/**
 * 权限
 * @param {*} key
 */
export function hasPermission (key) {
  return window.SITE_CONFIG['permissions'].indexOf(key) !== -1 || false
}


/**
 * 清除登录信息
 */
export function clearLoginInfo () {
  store.commit('resetStore')
  removeStorage('token')


  // Cookies.remove('token')
  window.SITE_CONFIG['dynamicMenuRoutesHasAdded'] = false
}

/**
 * 获取uuid
 */
export function getUUID () {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, c => {
    return (c === 'x' ? (Math.random() * 16 | 0) : ('r&0x3' | '0x8')).toString(16)
  })
}

/**
 * 获取svg图标(id)列表
 */
export function getIconList () {
  var res = []
  // TODO删除最后一位
  console.log(document.querySelectorAll('svg symbol').length)
  let list = document.querySelectorAll('svg symbol')
  // for (var index in list) {
  //   res.push(list[index].id)
  // }
  // 原始版本最后一行会有一个图标，其他位置被自动填充为空白，为了美观，将最后一个图标删除
  for (let i = 0; i < list.length - 1; i++) {
    res.push(list[i].id)
  }
  // document.querySelectorAll('svg symbol').forEach(item => {
  //   res.push(item.id)
  // })
  return res
}

/**
 * 城市名称显示
 * 入参 逗号分隔的城市id 1,2,4,8
 */
export function getRegionNameList (region) {
  let idList = region.split(',')
  let returnList = ' '
  for (let i = 0; i < idList.length; i++) {
    // Vue.filter('coverRegionName') 是一个function，第一个参数为值，第二个参数为层级是，现在默认第一个为3级，删除了国家和大区
    if (idList[i] && idList[i] !== '') {
      returnList += Vue.filter('coverRegionName')(idList[i], i + 1) + ','
    }
  }
  returnList = returnList.substring(0, returnList.length - 1)
  return returnList
}

/**
 * 树形数据转换
 * @param {*} data
 * @param {*} id
 * @param {*} pid
 */
export function treeDataTranslate (data, id = 'id', pid = 'pid') {
  var res = []
  var temp = {}
  if (data) {
    for (var i = 0; i < data.length; i++) {
      temp[data[i][id]] = data[i]
    }
    for (var k = 0; k < data.length; k++) {
      if (!temp[data[k][pid]] || data[k][id] === data[k][pid]) {
        res.push(data[k])
        continue
      }
      if (!temp[data[k][pid]]['children']) {
        temp[data[k][pid]]['children'] = []
      }
      temp[data[k][pid]]['children'].push(data[k])
      data[k]['_level'] = (temp[data[k][pid]]._level || 0) + 1
    }
  }
  return res
}

/**
 * 树形数据转换
 * @param {*} data
 * @param {*} id
 * @param {*} pid
 */
export function treeDataWithDisableTranslate (data, id = 'id', pid = 'pid') {
  var res = []
  var temp = {}
  for (var i = 0; i < data.length; i++) {
    temp[data[i][id]] = data[i]
  }
  for (var k = 0; k < data.length; k++) {
    if (!temp[data[k][pid]] || data[k][id] === data[k][pid]) {
      res.push(data[k])
      continue
    }
    if (!temp[data[k][pid]]['children']) {
      temp[data[k][pid]]['children'] = []
    }
    temp[data[k][pid]]['children'].push(data[k])
    temp[data[k][pid]]['disabled'] = true
    data[k]['_level'] = (temp[data[k][pid]]._level || 0) + 1
  }
  return res
}
// 同步ajax
export function ajax (url, func) {
  // 步骤一:创建异步对象
  var ajax = new XMLHttpRequest()
  // 步骤二:设置请求的url参数,参数一是请求的类型,参数二是请求的url,可以带参数,动态的传递参数starName到服务端
  ajax.open('post', url, false)
  // 步骤三:发送请求
  ajax.send()
  // 步骤四:注册事件 onreadystatechange 状态改变就会调用
  //   ajax.onreadystatechange = function () {
  //
  //   }
  if (ajax.readyState === 4 && ajax.status === 200) {
    // 步骤五 如果能够进到这个判断 说明 数据 完美的回来了,并且请求的页面是存在的
    return func(ajax)
  }
}

// 为json添加get方法
let storage = {}
function dP (url, name, func) {
  Object.defineProperty(Vue.prototype, name, {
    get: function () {
      if (!storage[name]) {
        let result = ajax(url, func)
        if (result) {
          storage[name] = result
        }
      }
      return storage[name]
    },
    set: function (val) {
      storage[name] = val
    }
  })
}
// 创建缓存
function createCache (url, name, func) {
  dP(url, name, (ajax) => {
    func(JSON.parse(ajax.responseText))
  })
  http.post(url).then(func)
}

let key = 'Cn'
// 初始化创建缓存
function init () {
// 判断中英文
  if (language === 'zh-CN') {
    key = 'Cn'
  } else {
    key = 'En'
  }
  setTimeout(() => {
    createCache(baseUrl + '/sys/commdict/commDictList', 'enums', (ajax) => {
      let data = ajax.data
      let enmu = {}
      if (data instanceof Array) {
        for (var i in data) {
          if (data[i].pid === 0) {
            enmu[data[i].dictType] = []
          }
        }
        for (var j in data) {
          if (data[j].pid !== 0) {
            let eachEnum = {
              name: data[j]['dictName' + key],
              code: data[j].dictValue,
              dictStatus: data[j].dictStatus
            }
            if (enmu[data[j].dictType]) {
              enmu[data[j].dictType].push(eachEnum)
            }
          }
        }
      }
      Vue.prototype.enums = enmu
    })
    createCache(baseUrl + '/sys/commregion/regionList', 'regionsSelect', (data) => {
      // let data = { result: [] }
      // data.result = [
      //   { 'createTime': null, 'createUser': null, 'delFlag': '0', 'parentRegionId': 0, 'regionCode': '1', 'regionGrade': '1', 'regionId': 1, 'regionNameCn': '中国', 'regionNameEn': 'zhongguo', 'remark': '', 'updateTime': null, 'updateUser': null },
      //   { 'createTime': null, 'createUser': null, 'delFlag': '', 'parentRegionId': 1, 'regionCode': '2', 'regionGrade': '2', 'regionId': 2, 'regionNameCn': '东北', 'regionNameEn': 'dongbei', 'remark': '', 'updateTime': null, 'updateUser': null },
      //   { 'createTime': null, 'createUser': null, 'delFlag': '', 'parentRegionId': 1, 'regionCode': '3', 'regionGrade': '2', 'regionId': 3, 'regionNameCn': '西北', 'regionNameEn': 'xibei', 'remark': '', 'updateTime': null, 'updateUser': null },
      //   { 'createTime': null, 'createUser': null, 'delFlag': '', 'parentRegionId': 2, 'regionCode': '4', 'regionGrade': '3', 'regionId': 4, 'regionNameCn': '辽宁省', 'regionNameEn': 'liaoningsheng', 'remark': '', 'updateTime': null, 'updateUser': null },
      //   { 'createTime': null, 'createUser': null, 'delFlag': '', 'parentRegionId': 2, 'regionCode': '5', 'regionGrade': '3', 'regionId': 5, 'regionNameCn': '山东省', 'regionNameEn': 'shandongsheng', 'remark': '', 'updateTime': null, 'updateUser': null },
      //   { 'createTime': null, 'createUser': null, 'delFlag': '', 'parentRegionId': 3, 'regionCode': '6', 'regionGrade': '3', 'regionId': 6, 'regionNameCn': '宁夏回族自治区', 'regionNameEn': 'ningxiahuizuzizhiqu', 'remark': '', 'updateTime': null, 'updateUser': null },
      //   { 'createTime': null, 'createUser': null, 'delFlag': '', 'parentRegionId': 3, 'regionCode': '7', 'regionGrade': '3', 'regionId': 7, 'regionNameCn': '山西省', 'regionNameEn': 'shanxisheng', 'remark': '', 'updateTime': null, 'updateUser': null },
      //   { 'createTime': null, 'createUser': null, 'delFlag': '', 'parentRegionId': 4, 'regionCode': '8', 'regionGrade': '4', 'regionId': 8, 'regionNameCn': '大连市', 'regionNameEn': 'dalianshi', 'remark': '', 'updateTime': null, 'updateUser': null }, { 'createTime': null, 'createUser': null, 'delFlag': '', 'parentRegionId': 4, 'regionCode': '9', 'regionGrade': '4', 'regionId': 9, 'regionNameCn': '鞍山市', 'regionNameEn': 'anshanshi', 'remark': '', 'updateTime': null, 'updateUser': null }, { 'createTime': null, 'createUser': null, 'delFlag': '', 'parentRegionId': 5, 'regionCode': '10', 'regionGrade': '4', 'regionId': 10, 'regionNameCn': '青岛市', 'regionNameEn': 'qingdaoshi', 'remark': '', 'updateTime': null, 'updateUser': null }, { 'createTime': null, 'createUser': null, 'delFlag': '', 'parentRegionId': 8, 'regionCode': '11', 'regionGrade': '5', 'regionId': 11, 'regionNameCn': '甘井子区', 'regionNameEn': 'ganjingziqu', 'remark': '', 'updateTime': null, 'updateUser': null }, { 'createTime': null, 'createUser': null, 'delFlag': '', 'parentRegionId': 8, 'regionCode': '12', 'regionGrade': '5', 'regionId': 12, 'regionNameCn': '高新园区', 'regionNameEn': 'gaoxinyuanqu', 'remark': '', 'updateTime': null, 'updateUser': null }]
      Vue.prototype.regionsSelect = loop({ 'value': 0, 'grade': 0 },
        data.data,
        'parentRegionId',
        'regionId',
        'regionName',
        'regionGrade',
        1,
        (origin) => {
        // 判断如果不是需要显示的省市区则不显示
          return true
        })
    })
    function loop (item, origin, pCodeKey, codeKey, nameKey, gradeKey, step, func) {
      func = function () {
        return true
      } && func
      function core (item) {
        let result = []
        for (let i = origin.length - 1; i > -1; i--) {
          if (item.value + '' === origin[i][pCodeKey] + '') {
            if (func(origin[i])) {
              item.children = result
              let tmp = {}
              tmp.value = origin[i][codeKey]
              tmp.label = origin[i][nameKey + key]
              tmp.item = origin[i]
              tmp.grade = origin[i][gradeKey]
              result.unshift(tmp)
              core(tmp)
            }
          }
        }
        return result
      }

      return core(item)
    }
  }, 1)
}

init()
